import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LandingLayoutDevComponent } from './landing-layout-dev/landing-layout-dev.component';

@Component({
  selector: 'app-landing-layout',
  imports: [LandingLayoutDevComponent],
  templateUrl: './landing-layout.component.html',
  styleUrl: './landing-layout.component.scss',
})
export class LandingLayoutComponent {
  isDev = environment.phase === 'dev' || environment.phase === 'local';
}
